module.exports = __webpack_public_path__ + "img/submit.e5b3fbc5.png";